import 'babel-polyfill'
import Vue from 'vue'
import CMM from '@nonameapp-core'
import cordovaLoader from '@/loader/cordova'
import VueCordova from '@/plugins/cordova'
import Vee from '@/plugins/vee'
import Vuelidate from 'vuelidate'
import VueMaterial from 'vue-material'
import Toasted from 'vue-toasted'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import '@nonameapp-sass'
import VueTouch from "vue-touch"

Vue.use(Vuelidate)
Vue.use(VueMaterial)
Vue.use(CMM._components)
Vue.use(Vee)
Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 5000
})
Vue.use(VueTouch, {name: 'v-touch'})

/*Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDtjEnR0k7-u5mpzRtdNYWeo5SOJ5l0nYw',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})
*/
Vue.material.locale.dateFormat = 'dd/MM/yyyy';
Vue.material.locale.days =['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
Vue.material.locale.shortDays =['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
Vue.material.locale.shorterDays =['D', 'L', 'M', 'M', 'G', 'V', 'S'];
Vue.material.locale.months =['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
Vue.material.locale.shortMonths =['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
Vue.material.locale.shorterMonths =['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'];

Vue.config.productionTip = false

const vueLoader = ({isMobile, el, store, router, components, template}) => {

  navigator.geolocation.watchPosition((position) => {
    store.commit("global/SET_GEO_POSITION", position)
  }, (error) => {
    store.commit("global/SET_GEO_POSITION", error)
    console.log("error", error)
  })

  const Instance = {
    el: el,
    store,
    router,
    components,
  }
  
  if (isMobile) {  /* eslint-disable */

    cordovaLoader((plugins) => {

      Vue.use(VueCordova, plugins)

      //Keyboard.hideFormAccessoryBar(false);
      
      //const devicePlatform = device.platform.toLowerCase()
      //const deviceModel = _.head(device.model.split(/[ .]/)).toLowerCase().replace(',', '-')

      //console.log('Running on ' + devicePlatform + ' ' + deviceModel)

      /* eslint-disable start*/
      new Vue({
        ...Instance,
        //template: C`${template} ${devicePlatform} ${deviceModel}`,
        template: `${template}`
      })
    })

  } else {
    new Vue({
      ...Instance,
      template: `${template}`
    })
  }
}

export default vueLoader


// WEBPACK FOOTER //
// ./src/loader/vue.js